import React, { Component } from 'react';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import i18n from 'I18n';

import LoadMoreSpinner from 'component/common/LoadMoreSpinner';
import ActivityLogFilterDropdown from 'component/profile/ActivityLogFilter';
import ActivityLogTransactionCard from 'component/profile/ActivityLogTransactionCard';

import { createAction, enLocaleNumberFormatter } from 'utils';
import { NO_TRANSACTION_HISTORY } from 'utils/Config';

import './ActivityLogMobile.scss';
import { getLogRewardItem } from 'models/ActivityLogs';

@connect(({ users, activityLogs, pullrefreshandloadmore }) => ({
  availablePoints: users.availablePoints,
  showNonReward: activityLogs.showNonReward,
  activityLogOriginList: activityLogs.activityLogOriginList,
  activityLogPageLink: activityLogs.activityLogPageLink,
  isLoadingLogs: activityLogs.isLoading,
  ...pullrefreshandloadmore,
  language: users.language,
}))
class ActivityLogMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    this.props.dispatch(createAction('activityLogs/fetchUserActivityLogs')({
      showNonReward: params.get("is_empty_reward") === "true"
    }));
  }

  componentWillUnmount() {
    this.props.dispatch(createAction('activityLogs/clearLogs')());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.props.dispatch(createAction('activityLogs/fetchUserActivityLogs')());
    }
  }

  transactionItemDidClicked = (id) => {
    if (!NO_TRANSACTION_HISTORY && id) {
      this.props.history.push(`/transaction_history_detail/${id}`);
    }
  };

  reachLimitInfoDidClicked = (id) => {
    if (id) {
      this.props.history.push(`/activity_log/${id}/reach_limit`);
    }
  };

  loadMore = () => {
    if (this.props.activityLogPageLink) {
      this.props.dispatch(
        createAction('pullrefreshandloadmore/updateState')({
          ActivityLogLoadingMore: true,
        }),
      );
      this.props.dispatch(
        createAction('activityLogs/uerActivityLogsLoadMore')(),
      );
    }
  };

  parseActivityLog = () => {
    let parsedActivityLogList = [];
    if (
      this.props.activityLogOriginList &&
      this.props.activityLogOriginList.length > 0
    ) {
      parsedActivityLogList = this.props.activityLogOriginList.map((item) => {
        let content = [];
        if (item?.points != null) {
          content.push(
            getLogRewardItem(item?.points, "pts")
          );
        }
        if (item?.tpe != null) {
          content.push(
            getLogRewardItem(item?.tpe, "pp")
          );
        }
        if (item?.coupon != null) {
          content.push(
            getLogRewardItem(item?.coupon, i18n.t('home_coupons'))
          );
        }
        if (item?.ticket != null) {
          content.push(
            getLogRewardItem(item?.ticket, i18n.t('home_tickets'))
          );
        }
        if (item?.stamps != null) {
          content.push(
            getLogRewardItem(item?.stamps, "stamps")
          );
        }
        return {
          id: item.activityId,
          name: this.props.t(item.title),
          date: item.activityTime,
          content: content,
          icon: item.icon,
          srcSet: item?.srcSet,
          subTitle: item.subTitle,
          reachLimit: item.reachLimit,
          transactionInfo: item?.transactionInfo,
        };
      });
    }
    return parsedActivityLogList;
  };

  renderTableData = ({
    dataList,
    isLoading = false,
    isLoadingMore = false,
  }) => {
    if (isLoading) {
      return (
        <tbody>
          <tr>
            <LoadMoreSpinner />
          </tr>
        </tbody>
      );
    }
    if (dataList && dataList.length > 0) {
      return (
        <tbody>
          {dataList.map((item, index) => {
            return (
              <>
                <tr key={item.id}>
                  <th className="item_name">
                    <div className="type-icon">
                      {item?.icon ? (
                        <img
                          alt="type-icon"
                          src={item?.icon}
                          srcSet={item?.srcSet}
                        />
                      ) : null}
                    </div>
                    <div>
                      <div className="body-3">{item.name}</div>
                      {item?.subTitle && (
                        <div
                          className={`item-sub-title ${
                            this.isMobile ? 'tag-menu-1' : 'body-2'
                          }`}
                        >
                          {item?.subTitle}
                        </div>
                      )}
                      <div className="item-sub-title body-1">{item?.date}</div>
                    </div>
                  </th>
                  <th
                    className="item-info-content field-text"
                    onClick={() => {
                      if (item?.reachLimit) {
                        this.reachLimitInfoDidClicked(item.id);
                      }
                    }}
                  >
                    {item?.reachLimit ? (
                      <img
                        className="reach-limit-info g3_color_image"
                        src="/action/info.svg"
                      />
                    ) : null}
                    <div className="item-content">
                      {item?.content?.map((contentItem, index) => (
                        <div key={index}>{contentItem}</div>
                      ))}
                    </div>
                  </th>
                </tr>
                {item?.transactionInfo?.id ? (
                  <tr className="activity-log-transaction">
                    <th
                      colspan="2"
                      onClick={() => {
                        this.transactionItemDidClicked(item.transactionInfo.id);
                      }}
                    >
                      <ActivityLogTransactionCard
                        transactionInfo={item?.transactionInfo}
                      />
                    </th>
                  </tr>
                ) : null}
              </>
            );
          })}
          {isLoadingMore && (
            <tr>
              <LoadMoreSpinner />
            </tr>
          )}
        </tbody>
      );
    }
    return (
      <tbody>
        <tr className="no-record-tr">
          <td>
            <p className="no_record_message subheading">
              {this.props.t('no_record_click')}{' '}
              <Link to="/offer/LATEST">{this.props.t('here')}</Link>{' '}
              {this.props.t('to_earn_points')}
            </p>
          </td>
        </tr>
      </tbody>
    );
  };

  tableView = (title, itemList, isLoading = false, isLoadingMore = false) => {
    return (
      <div className="reward_status_table_view activity-log-table-view">
        <div className="reward_status_table_head">
          <div className="reward_status_table_head_item subheading">
            {title}
          </div>
          <div className="reward_status_table_head_item subheading">
            {this.props.t('earn_burn')}
          </div>
        </div>
        <div
          className="reward-status-table-body activity-log-table-content scroll-table"
          onScroll={(event) => {
            if (
              event.nativeEvent.target.scrollTop +
                event.nativeEvent.target.clientHeight >
                event.nativeEvent.target.scrollHeight * 0.9 &&
              !isLoadingMore
            ) {
              this.loadMore();
            }
          }}
        >
          <Table className="reward-status-table activity-log-table" borderless>
            {this.renderTableData({
              dataList: itemList,
              isLoading,
              isLoadingMore,
            })}
          </Table>
        </div>
      </div>
    );
  };

  render() {
    return (
      <Container className="activity-log-mobile-page-container reward-status-mobile-page-container">
        <Row>
          <Col>
            <div className="activity-log-top-bar">
              <ActivityLogFilterDropdown
                onClick={() => {
                  this.props.dispatch(
                    createAction('activityLogs/fetchUserActivityLogs')({
                      showNonReward: !this.props.showNonReward,
                    }),
                  );
                }}
                isChecked={!!this.props.showNonReward}
              />
            </div>
            {this.tableView(
              this.props.t('activity'),
              this.parseActivityLog(),
              this.props.isLoadingLogs,
              this.props.ActivityLogLoadingMore || false,
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(withTranslation()(ActivityLogMobile));
